import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"color":"#546270"},
  class: "el-dialog__title"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { class: "d-inline-flex gap-2" }
const _hoisted_5 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogBox',
  props: {
  dialogVisible: { type: Boolean },
  cancelVisible: { type: Boolean, default: true },
  message: { type: String },
  title: { type: String },
  confirmText: { type: String, default: "Ok" },
  closeText: { type: String, default: "Cancel" },
  confirmVisible: { type: Boolean, default: true },
  busyText: { type: String, default: "" },
  width: { type: String }
},
  emits: ["close", "confirm"],
  setup(__props) {

const props = __props;




return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.dialogVisible,
    title: __props.title,
    "close-on-click-modal": false,
    width: __props.width,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    class: "dialog-box"
  }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("b", null, _toDisplayString(__props.title), 1)
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("span", { innerHTML: __props.message }, null, 8, _hoisted_2)
      ])
    ]),
    _: 2
  }, [
    (__props.cancelVisible|| __props.confirmVisible)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (__props.confirmVisible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary text-white",
                      disabled: !!__props.busyText,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
                    }, _toDisplayString(__props.busyText || __props.confirmText || "Ok"), 9, _hoisted_5))
                  : _createCommentVNode("", true),
                (__props.cancelVisible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-outline-primary text-primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                    }, _toDisplayString(__props.closeText || "Cancel"), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["model-value", "title", "width"]))
}
}

})